<template>
  <div class="form">
    <h2>Индивидуальные достижения</h2>

    <template v-if="store.application.achievements?.length">
      <div
        class="form form--fieldset"
        v-for="achievement in store.application.achievements"
        :key="achievement.id"
      >
        <div class="join join--center join--between join--full">
          <span>{{ achievement.achievement }}</span>
          <span class="badge badge--success badge--w-md" :class="{'badge--active': achievement.mark > 0}">
            {{ badgeText(achievement) }}
          </span>
        </div>
      </div>
    </template>

    <div v-else class="card card--info">
      <img class="card__icon icon icon--primary" src="~images/info.svg" v-svg-inline/>
      <p>Индивидуальные достижения не добавлены</p>
    </div>
  </div>
</template>

<script setup>
import { useApplicationStore } from '@widgets/application-profile'
import { plural } from '@shared/lib'

defineProps({
  readonly: { type: Boolean, default: false },
})

const store = useApplicationStore()

const badgeText = (achievement) => {
  if (achievement.mark === null) return 'Ожидает подтверждения'
  if (achievement.mark === 0) return 'Не подтверждено'
  return `${achievement.mark} ${plural(achievement.mark, 'балл', 'балла', 'баллов')}`
}
</script>
